(function() {
    'use strict';
  
    angular
      .module('iqxCore')

      .config(config);

      config.$inject = [
        'angularAuth0Provider'
      ];
    
      function config(
        angularAuth0Provider
      ) {
        // Initialization for the angular-auth0 library
        angularAuth0Provider.init({
          clientID: AUTH0_CLIENT_ID,
          domain: AUTH0_DOMAIN,
          responseType: 'token id_token',
          redirectUri: AUTH0_CALLBACK_URL,
          scope: AUTH0_SCOPE,
          audience: AUTH0_AUDIENCE
        });
    
      }
  
})()